import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "./ui/button";
import { GoogleLogo } from "@phosphor-icons/react";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function GoogleButton({ profession, label = "Continuar com Google" }) {
  const start = () => {
    if (profession) sessionStorage.setItem("pending_profession", profession);
    else sessionStorage.removeItem("pending_profession");
    const redirectUrl = window.location.origin + "/app";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <Button type="button" variant="outline" onClick={start} className="w-full rounded-md border-slate-300 bg-white hover:bg-slate-50 text-slate-800" data-testid="google-login-button">
      <GoogleLogo size={18} weight="bold" className="mr-2 text-[#4285F4]" /> {label}
    </Button>
  );
}

export function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { loginWithGoogle } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    const profession = sessionStorage.getItem("pending_profession");
    sessionStorage.removeItem("pending_profession");
    loginWithGoogle(sessionId, profession).then((r) => {
      window.history.replaceState(null, "", location.pathname);
      if (r.ok) { toast.success("Bem-vindo!"); navigate("/app", { replace: true }); }
      else { toast.error(r.error); navigate("/login", { replace: true }); }
    });
  }, [location, loginWithGoogle, navigate]);

  return <div className="min-h-screen flex items-center justify-center text-slate-500" data-testid="auth-callback">Entrando com Google...</div>;
}
